import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Col, Form, Input, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import { Store } from '../../../../store';
import {
    setGuiasPesquisa,
} from '../../../../store/ducks/pageConfig';
import { ModalConstructor } from '../../../../shared/components';
import HistoricoPesquisa from '../HistoricoPesquisa/HistoricoPesquisa';
import PesquisaEbooks from './PesquisaEbooks';
import {
    ConsultaHelper,
    ToastifyHelper,
    APIHelper,
} from '../../../../shared/helpers';
import {
    changeSearch,
    changeSearchOptions,
} from '../../../../store/ducks/pesquisa';
import PesquisaArquivo from './PesquisaArquivo';
import PesquisaAutoridades from './PesquisaAutoridades';
import PesquisaAcessibilidade from './PesquisaAcessibilidade';
import PesquisaNovasAquisicoes from './PesquisaNovasAquisicoes';
import PesquisaPlanoEnsino from './PesquisaPlanoEnsino';
import { ConsultaAPI, ParametrosAPI } from '../../../../shared/http-requests';
import PesquisaJurisprudencia from './PesquisaJurisprudencia';
import { useAccessibilityContext } from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import useDebounce from '../../../../shared/helpers/useDebounce';
import PesquisaAtosNormativosV2 from './PesquisaAtosNormativosV2';
import { useSearchContext } from '../../../../shared/contexts/SearchContextProvider';
import GeneralSearch from './v2/GeneralSearch';
import AdvancedSearch from './v2/AdvancedSearch';
import MultimeiosSearch from './v2/MultimeiosSearch';
import PrefiltersReset from './v2/PrefiltersReset';
import Axios from "axios";

const SearchBar = (props) => {
    const {
        location,
        history,
        guiasPesquisaRx,
        instituicaoRx = {},
        opcoesConsulta,
        guiaSelecionada,
        loadingRx,
        opcoesConsultaPlanoEnsino
    } = props;
    const { t } = useTranslation();
    // ? Mensagem de erro, inicialmente inativa:
    const [error, setError] = useState(false);
    // ? Botão de abrir/ fechar o modal do histórico de busca, inicialmente fechado:
    const [historicoOpen, setHistoricoOpen] = useState(false);

    const guiaPadrao = guiasPesquisaRx.find(guia => guia.ordem === 0);

    const formRef = useRef(null);
    const { setHasSearch } = useAccessibilityContext();
    const { lang } = useAppContext();
    const { makeAndRunSearch } = useSearchContext();

    useEffect(() => {
        /**
         * Avisando o AccessibilityBar que existe busca
         */
        setHasSearch(true);

        return () => {
            setHasSearch(false)
        }
    }, []);

    const { habilita_kids_pesq_catalogo = false } = instituicaoRx;
    const [autoCompleteTerms, setAutoCompleteTerms] = useState(null)
    const [lastModification, setLastModification] = useState(null)

    //? Valida se existe as opcoes de consulta no redux. Se não existir, seta padrão conforme a guia.
    useEffect(() => {
        if (lang !== null) {
            if (opcoesConsulta.length === 0)
                resetOpcoesPesquisa(guiaSelecionada);

            ParametrosAPI.buscarDadosSecao1()
                .then(response => {
                    Store.dispatch(setGuiasPesquisa(response.data));
                })
                .catch(error => APIHelper.tratarErro(error));
        }
    }, [lang]);

    // ? LUIZ 14/10 - comentado esse useEffect.
    // ? Nao achei uso pra ele, enviar a ref do form para a store estava travando o Redux Devtools.
    // useEffect(() => {
    //     if (formRef.current !== null) {
    //         Store.dispatch(addFormRef(formRef));
    //     }
    // }, [formRef]);

    const mudarGuiaPesquisa = guia => {
        if (guia === '')
            guia = guiasPesquisaRx.find(g => g.ordem === 0).codigo;
        ConsultaHelper.limparConsulta(() => resetOpcoesPesquisa(guia));
        const paramSearch = queryString.parse(location.search);
        history.push({
            pathname: `/${guia}`,
            search: paramSearch?.mobileView ? `?mobileView=${paramSearch.mobileView}` : '',
        });
    };

    const autoCompleteValidations = (term, searchBy) => {
        if(typeof term !== 'string' || term.trim() === '') {
            return false;
        }

        const allowedSearchBy = ['TITULO', 'INDICE_1', 'AUTOR', 'INDICE_3', 'ASSUNTO', 'INDICE_2', 'LIVRE'];
        return allowedSearchBy.includes(searchBy);
    }
    const autoComplete = async(term, searchBy, index = 0, cancelToken = null) => {

        if(!autoCompleteValidations(term, searchBy)){
            setAutoCompleteTerms(null)
            return;
        }

        searchBy = searchBy === 'INDICE_1' ? 'TITULO' : searchBy;
        searchBy = searchBy === 'INDICE_3' ? 'AUTOR' : searchBy;
        searchBy = searchBy === 'INDICE_2' ? 'ASSUNTO' : searchBy;


        const response =  ConsultaAPI.autoComplete(term, searchBy.toLowerCase(), cancelToken)
        if(response){
            const {data} = await response;
            if(data){
                /**
                 * Logica especifica pesquisa avançada pois pode ter até 3 campos de busca
                 */
                if(props.guiaSelecionada === 'pesquisa_avancada'){

                    if(autoCompleteTerms?.length){
                        const current =  JSON.parse(JSON.stringify(autoCompleteTerms));
                        current[index] = data;
                        setAutoCompleteTerms(current)
                        return true;
                    }

                    setAutoCompleteTerms([data])
                }else{
                    setAutoCompleteTerms(data)
                }
            }
        }
    }

    const [debouncedAutoComplete, clearDebounce] = useDebounce(autoComplete, 500)



    useEffect(() => {
        const cancelTokenSrc = Axios.CancelToken.source()
        const { token }  = cancelTokenSrc
        let [options] = props.opcoesConsulta;
        let index = 0;

        if(props.guiaSelecionada === 'pesquisa_avancada'){
            if(lastModification !== null){
                const modifiedItem = props.opcoesConsulta?.find((x, i)=> {
                    if(x.termo !== lastModification[i]?.termo || x.option !== lastModification[i]?.option){
                        index = i;
                        return x;
                    }
                });

                if(modifiedItem)
                    options = modifiedItem;
            }
        }


        if(options){
            const {option,termo} = options;
            debouncedAutoComplete(termo, option, index, token)
            setLastModification(JSON.parse(JSON.stringify(props.opcoesConsulta)))
        }

        return () => {
            clearDebounce();
        }
    }, [props.opcoesConsulta]);


    const getSearch = () => {
        switch (guiaSelecionada) {
            case 'pesquisa_geral':
                return (
                    <GeneralSearch
                        autoCompleteTerms={autoCompleteTerms}
                        onChangeSearch={(data) => {
                            debouncedAutoComplete(data.searchTerm, data.searchOption)
                        }}
                    />
                );
            case 'pesquisa_avancada':
                return (
                    <AdvancedSearch
                        error={error}
                        loading={loadingRx}
                        autoCompleteTerms={autoCompleteTerms}
                        onChangeSearch={(data, index) => {
                            debouncedAutoComplete(data.searchTerm, data.searchOption, index)
                        }}
                    />
                );
            case 'e_books':
                return (
                    <PesquisaEbooks
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                    />
                );
            case 'arquivo':
                return (
                    <PesquisaArquivo
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                    />
                );
            case 'atos_normativos':
                return (
                    <PesquisaAtosNormativosV2
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                    />
                );
            case 'jurisprudencia':
                return (
                    <PesquisaJurisprudencia
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                    />
                );
            case 'autoridades':
                return (
                    <PesquisaAutoridades
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                    />
                );
            case 'acessibilidade':
                return (
                    <PesquisaAcessibilidade
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                    />
                );
            case 'novas_aquisicoes':
                return (
                    <PesquisaNovasAquisicoes
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                        location={location}
                    />
                );
            case 'plano_ensino':
                return (
                    <PesquisaPlanoEnsino
                        error={error}
                        loading={loadingRx}
                        opcoesConsulta={opcoesConsulta}
                        location={location}
                        opcoesConsultaPlanoEnsino={
                            opcoesConsultaPlanoEnsino
                        }
                    />
                );
            case 'multimeios':
                return(
                    <MultimeiosSearch loading={loadingRx} error={error} />
                )
            default:
                return false;
        }
    };

    const isGuiaAtiva = codigoGuia => {
        let comparador = guiaSelecionada;
        if (comparador === guiaPadrao.codigo) comparador = '';
        return comparador === codigoGuia;
    };

    const getTitleSelectedTab = () => {
        if(guiasPesquisaRx?.length > 0){
            const selected = guiasPesquisaRx.find(x => x.codigo === guiaSelecionada);
            if(selected){
                return selected.titulo;
            }
        }
        return '';
    }

    const resetOpcoesPesquisa = novaGuia => {
        const options = [];
        switch (novaGuia) {
            case 'pesquisa_geral':
                options.push({ option: 'LIVRE', termo: '' });
                break;
            case 'pesquisa_avancada':
            case 'acessibilidade':
            case 'novas_aquisicoes':
            case 'plano_ensino':
                options.push({ option: 'TITULO', termo: '' });
                break;
            case 'e_books':
                options.push({ option: 'LIVRE', termo: '' });
                break;
            case 'arquivo':
                options.push({ option: 'obra', termo: '' });
                break;
            case 'atos_normativos':
            case 'jurisprudencia':
                options.push({option: null, termo: ''});
                break;
            case 'autoridades':
                options.push({ option: 'AUTORIDADE_TODOS', termo: '' });
                break;
            default:
                return;
        }
        Store.dispatch(changeSearchOptions(options));
    };

    const handleKeyDown = (e, codigoGuia) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            mudarGuiaPesquisa(codigoGuia)
        }
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target)
        let formObj = Object.fromEntries(formData.entries());
        if(!formObj?.q || formObj?.q?.trim() === '') {
            ToastifyHelper.warning("Você precisa digitar um termo para continuar!")
            return;
        }
        // Tratamento de parâmetros para realizar a busca paginada
        if(guiasPesquisaRx.length) {
            const isPesquisaPaginada = !!guiasPesquisaRx.find(guia => guia.codigo === guiaSelecionada && guia.usa_consulta_paginada);
            if(isPesquisaPaginada) {
                Store.dispatch(changeSearch(false))
                formObj = {
                    ...formObj,
                    page: 1,
                    perPage: 20,
                    // orderBy: process.env.REACT_APP_CONSULTA_PAGINADA_ORDENACAO ?? process.env.ORDENACAO,
                    direction: 'C'
                };
            }
        }
        makeAndRunSearch(formObj)
    }

    const formContent = () => (
        <div className="content__left__header">

            {
                guiasPesquisaRx?.length > 0 ? (
                    <>
                                    <span className="so_para_leitores_tela">{t('SearchBar.MensagemLeitorDeTela1', {
                                        total_tabs: guiasPesquisaRx?.length,
                                        title_selected: getTitleSelectedTab()
                                    })}</span>
                        <a className="so_para_leitores_tela"
                           href="#edit-termo">{t('SearchBar.MensagemLeitorDeTela2')}</a>
                    </>
                ) : ''
            }


            <Row className="">
                <div className="align-c d-md-block d-none">
                    {guiasPesquisaRx.map(guia => {
                        //?A guia padrão redireciona pra raiz da aplicação
                        const codigoGuia = guia.ordem === 0 ? '' : guia.codigo;

                        /**
                         * Lógica para não mostrar a aba kids se a coluna habilita_kids_pesq_catalogo não for true
                         */
                        if (codigoGuia === 'catalogos/kids' && !habilita_kids_pesq_catalogo) {
                            return;
                        }

                        return (
                            <span
                                onKeyDown={e => handleKeyDown(e, codigoGuia)}
                                role="button"
                                tabIndex={0}
                                onMouseUp={() => mudarGuiaPesquisa(codigoGuia)}
                                key={`link-${codigoGuia}`}
                                className={classnames('tag3 s12 negrito guia_pesquisa', {
                                    'active bktema branco': isGuiaAtiva(codigoGuia),
                                })}
                            >
                                        {guia.icone ? (
                                            <FontAwesomeIcon icon={['fa', guia.icone]} />
                                        ) : null}
                                {guia.titulo}
                                        </span>
                        );
                    })}
                </div>

                <div className="d-md-none d-block col-12 p-3 0 mb-2 bkdark10">

                    <div className='rotulo'>
                        {t('TipoPesquisas')}
                    </div>
                    <Input
                        type="select"
                        className="rad10"
                        onChange={e =>
                            mudarGuiaPesquisa(e.target.value)
                        }
                        value={guiaSelecionada}
                    >
                        {guiasPesquisaRx.map(guia => {
                            const { codigo } = guia;

                            /**
                             * Lógica para não mostrar a aba kids se a coluna habilita_kids_pesq_catalogo não for true
                             */
                            if (codigo === 'catalogos/kids' && !habilita_kids_pesq_catalogo) {
                                return;
                            }

                            return (
                                <option
                                    key={`option-${guia.codigo}`}
                                    value={guia.codigo}
                                >
                                    {' '}
                                    {guia.titulo}{' '}
                                </option>
                            );
                        })}

                        <option
                            value='pesquisa_acessibilidade'
                        >
                            {t('AccessibilityBar.IrParaBuscaAcessivel')}
                        </option>
                    </Input>
                </div>

            </Row>
                {getSearch()}
            <Row>
                <Col className="mt-3">
                    <div
                        className="preto80 align-c hover hpreto link float-left rad5 click py-1 px-2"
                        onClick={() =>
                            setHistoricoOpen(!historicoOpen)
                        }
                    >
                        <FontAwesomeIcon
                            icon="history"
                            className="mr-2"
                        />
                        <span className="f500">
                                        {t('Historico')}
                                    </span>
                    </div>
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col md={{size: 8, offset: 2}}>
                    <PrefiltersReset displayOnlyMobile={false}/>
                </Col>
            </Row>
        </div>
    )


    if (guiasPesquisaRx.length)
        return (
            <Row className="header__search__content rad2 p-md-3 p-1 bktema60 animated fadeIn">
                <ModalConstructor
                    closeable
                    closeAction
                    size="xl"
                    title={t('HistoricoPesquisa')}
                    open={historicoOpen}
                    setOpen={setHistoricoOpen}
                >
                    <HistoricoPesquisa />
                </ModalConstructor>
                {
                    ['pesquisa_geral', 'pesquisa_avancada', 'multimeios'].includes(guiaSelecionada) ? (
                        <div className="search__content__left col-xs-10 row bkbranco p-0 p-sm-3 p-md-4">
                            {formContent()}
                        </div>
                    ) : (
                        <Form
                            innerRef={formRef}
                            name="consultar"
                            className="search__content__left col-xs-10 row bkbranco p-0 p-sm-3 p-md-4"
                            id="consultar"
                            onSubmit={e => handleFormSubmit(e)}
                        >
                            {formContent()}
                        </Form>
                    )
                }
            </Row>
        );
    return null;
};

const mapStateToProps = state => ({
    atividadesRx: state.pageConfig.atividades,
    loadingRx: state.pageConfig.loading,
    langRx: state.pageConfig.lng,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    opcoesConsultaPlanoEnsino: state.pesquisa.opcoesConsultaPlanoEnsino,
    instituicaoRx: state.instituicao.data,
});

export default connect(mapStateToProps)(withRouter(SearchBar));
